import React, { PropsWithChildren, createContext, useContext } from 'react';

import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

type PinboardWidgetWrapperContextType = {
    isGenerativeAi: boolean | undefined;
    setIsGenerativeAi: (value: boolean) => void;
    componentKey: IComponentKey | undefined;
    isLoading: boolean;
};

interface Props extends PropsWithChildren {
    value: PinboardWidgetWrapperContextType;
}

const PinboardWidgetWrapperContext = createContext<PinboardWidgetWrapperContextType>({
    isGenerativeAi: undefined,
    setIsGenerativeAi: () => {},
    componentKey: undefined,
    isLoading: false,
});

export const PinboardWidgetWrapperProvider = ({ children, value }: Props) => {
    return <PinboardWidgetWrapperContext.Provider value={value}>{children}</PinboardWidgetWrapperContext.Provider>;
};

export const usePinboardWidgetWrapperContext = () => {
    return useContext(PinboardWidgetWrapperContext);
};
